import { css, cx } from '@emotion/css'
import { theme } from '../styles/theme.js'
import { Card } from '../components/Card.jsx'
import { Button } from '../components/Button.jsx'
import { ArrowRight } from 'lucide-react'

const styles = {
  container: css({
    paddingTop: theme.spacing.sm,
  }),
  hero: css({
    marginBottom: theme.spacing.xl,
  }),
  title: css({
    fontSize: '32px',
    lineHeight: '1.1',
    fontWeight: 700,
    letterSpacing: '-0.03em',
    marginBottom: theme.spacing.md,
  }),
  subtitle: css({
    fontSize: theme.typography.fontSize.lg,
    color: theme.colors.textMuted,
    maxWidth: '32ch',
  }),
  sectionTitle: css({
    fontSize: theme.typography.fontSize.xl,
    fontWeight: 600,
    marginBottom: theme.spacing.md,
  }),
  grid: css({
    display: 'grid',
    gap: theme.spacing.md,
    gridTemplateColumns: '1fr',
    '@media (min-width: 480px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
  }),
  stat: css({
    textAlign: 'center',
    padding: theme.spacing.md,
  }),
  statValue: css({
    fontSize: '28px',
    fontWeight: 700,
    color: theme.colors.primary,
  }),
  statLabel: css({
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.textMuted,
    marginTop: '4px',
  }),
}

const Home = () => {
  return (
    <div className={styles.container}>
      <div className={styles.hero}>
        <h1 className={styles.title}>Welcome to Genesis.</h1>
        <p className={styles.subtitle}>
          The foundation of something new. Built mobile-first from day one.
        </p>
      </div>

      <section style={{ marginBottom: theme.spacing.xxl }}>
        <h2 className={styles.sectionTitle}>Quick stats</h2>
        <div className={styles.grid}>
          <Card>
            <div className={styles.stat}>
              <div className={styles.statValue}>128</div>
              <div className={styles.statLabel}>Days active</div>
            </div>
          </Card>
          <Card>
            <div className={styles.stat}>
              <div className={styles.statValue}>47</div>
              <div className={styles.statLabel}>Sessions</div>
            </div>
          </Card>
        </div>
      </section>

      <section>
        <h2 className={styles.sectionTitle}>Get started</h2>
        <Card>
          <p style={{ marginBottom: theme.spacing.md, color: theme.colors.textMuted }}>
            This boilerplate is ready for you to build upon. Everything is mobile-first,
            uses React + Vite, and follows the project coding conventions.
          </p>
          <Button>
            Begin journey <ArrowRight size={18} />
          </Button>
        </Card>
      </section>
    </div>
  )
}

export { Home }
